/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const ModSubscriptions: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M16 15.24C16.01 15.44 15.95 15.62 15.79 15.77C15.66 15.92 15.48 16 15.27 16H13.64C13.44 16 13.28 15.93 13.13 15.8C12.99 15.67 12.92 15.51 12.91 15.32C12.82 13.69 12.44 12.14 11.76 10.68C11.09 9.22 10.21 7.94 9.13 6.86C8.06 5.78 6.79 4.9 5.32 4.23C3.86 3.55 2.31 3.17 0.68 3.07C0.49 3.06 0.33 2.99 0.2 2.85C0.07 2.71 0 2.54 0 2.35V0.73C0 0.52 0.08 0.34 0.23 0.21C0.36 0.07 0.53 0 0.73 0H0.76C2.75 0.1 4.64 0.55 6.46 1.36C8.28 2.17 9.89 3.28 11.3 4.7C12.72 6.11 13.83 7.72 14.64 9.54C15.44 11.35 15.9 13.25 16 15.24ZM10.18 15.21C10.19 15.42 10.13 15.6 9.99 15.76C9.85 15.92 9.67 16 9.45 16H7.92C7.73 16 7.57 15.94 7.43 15.81C7.29 15.68 7.22 15.53 7.2 15.34C7.03 13.61 6.34 12.12 5.1 10.89C3.86 9.66 2.39 8.96 0.66 8.8C0.47 8.78 0.31 8.7 0.19 8.57C0.06 8.43 0 8.27 0 8.08V6.55C0 6.33 0.08 6.15 0.24 6.02C0.37 5.89 0.53 5.83 0.73 5.83H0.79C2 5.93 3.16 6.23 4.27 6.74C5.37 7.24 6.35 7.93 7.2 8.8C8.06 9.65 8.75 10.64 9.26 11.74C9.78 12.84 10.08 14 10.18 15.21ZM4.37 13.81C4.37 13.21 4.15 12.69 3.73 12.27C3.3 11.85 2.79 11.64 2.19 11.64C1.58 11.64 1.07 11.86 0.64 12.28C0.21 12.7 0 13.22 0 13.82C0 14.42 0.2 14.93 0.63 15.36C1.06 15.79 1.57 16 2.18 16C2.79 16 3.3 15.79 3.73 15.36C4.16 14.93 4.37 14.42 4.37 13.81Z'
			/>
		</Svg>
	);
};

export { ModSubscriptions };
